import axios from 'axios';
import { ACCESS_TOKEN } from './token';
import UserProfile from '../components/User';
import { config } from '../config';
import * as responseCache from './responseCache';

const apiUrl = config.url.API_ENDPOINT;

// console.log(import.meta);

// const baseURL = import.meta.env.REACT_APP_API_ENDPOINT ? import.meta.env.REACT_APP_API_ENDPOINT : apiUrl;
const baseURL = apiUrl;

const api = axios.create({
    baseURL: baseURL
})

const isDev = process.env.NODE_ENV === 'development';

// Where a 401 is an answer rather than an expiry. Signing in with the wrong
// password and having a token quietly go stale are different events, and only
// the second one should tear the session down.
//
// Deliberately just login. A 401 from the refresh endpoint means the refresh
// token itself is dead, which really is the end of the session - excluding it
// would leave somebody stranded in a half-signed-in state with no way out.
const AUTH_ENDPOINTS = ['/auth/login/'];

api.interceptors.request.use(
    (config) => {
        const accessToken = window.sessionStorage.getItem(ACCESS_TOKEN);
        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        if (isDev) {
            console.log('Starting Request', config);
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    (response) => {
        if (isDev) {
            console.log('Response:', response);
        }
        // Anything that was not a read has changed something, so every cached
        // answer is now suspect. Emptied here rather than at the call sites so
        // no new mutation can forget to - the failure that would cause is a
        // bill still listed as unapproved after somebody approved it, which
        // reads as the screen being broken.
        //
        // Blanket rather than targeted: working out which answers a given write
        // invalidates is a guess, and clearing everything costs one refetch
        // while guessing wrong costs trust in the figures.
        if ((response.config?.method || 'get').toLowerCase() !== 'get') {
            responseCache.clear();
        }
        return response;
    },
    (error) => {
        // A 401 normally means the session has gone, and logging out reloads
        // the page to clear every trace of it.
        //
        // Not on the auth endpoints. There a 401 means "those credentials are
        // wrong" - the caller is not signed in and has nothing to clear. The
        // reload was firing before React could paint, so a mistyped password
        // silently refreshed the login page instead of saying anything, and
        // both the inline error and the snackbar were wiped on the way.
        const url = error.config?.url || '';
        const isAuthAttempt = AUTH_ENDPOINTS.some((path) => url.includes(path));

        if (error.response && error.response.status === 401 && !isAuthAttempt) {
            UserProfile.logout();
        }
        return Promise.reject(error);
    }
);

export default api;